<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5 v-show="!isModal">Detail Anggota</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No Anggota</b-col>
                    <b-col>{{ anggota.no }} <span style="margin-left: 10px; font-size: 13px;" v-if="anggota.statusPembayaran == 1" class="badge badge-success">Lancar</span></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No Member</b-col>
                    <b-col v-if="anggota.noMember != null">{{ anggota.noMember }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Terdaftar di</b-col>
                    <b-col>{{ anggota.cabang.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Waktu Pendaftaran</b-col>
                    <b-col>{{ $helper.changeDateFormat(anggota.createdAt) }} {{ $helper.changeDateFormatGetHour(anggota.createdAt) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Petugas Pendaftar</b-col>
                    <b-col>{{ $helper.formatNameAndNik(anggota.createdBy.name) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Nasabah</b-col>
                    <b-col>{{ anggota.isActive ? 'Aktif' : 'Blacklist' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Verifikasi</b-col>
                    <b-col v-if="anggota.statusVerifikasi == STATUS_VERIFIKASI_ANGGOTA.PENDING">Belum Terverifikasi</b-col>
                    <b-col v-else>Sudah Terverifikasi</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA KTP</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Anggota</b-col>
                    <b-col>{{ anggota.nama }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                    <b-col>{{ anggota.identitas.length>0 ?anggota.identitas[0].jenisIdentitas : "-" }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nomor Identitas</b-col>
                    <b-col>{{ anggota.identitas.length>0 ?anggota.identitas[0].noIdentitas : "-" }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Kelamin</b-col>
                    <b-col v-if="anggota.detail.jenisKelamin != null">
                       <div v-if="anggota.detail.jenisKelamin == 'L'">Laki - laki</div>
                       <div v-if="anggota.detail.jenisKelamin == 'P'">Perempuan</div>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Perkawinan</b-col>
                    <b-col v-if="anggota.detail.statusPerkawinan != null">
                       <div v-if="anggota.detail.statusPerkawinan == 'BK'">Belum Kawin</div>
                       <div v-if="anggota.detail.statusPerkawinan == 'KA'">Kawin</div>
                       <div v-if="anggota.detail.statusPerkawinan == 'CH'">Cerai Hidup</div>
                       <div v-if="anggota.detail.statusPerkawinan == 'CM'">Cerai Mati</div>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kewarganegaraan</b-col>
                    <b-col v-if="anggota.detail.kewarganegaraan != null">{{ anggota.detail.kewarganegaraan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kota Lahir</b-col>
                    <b-col>{{ anggota.detail.kotaLahir.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Lahir</b-col>
                    <b-col>
                        <div>{{$helper.changeDateFormat(anggota.detail.tanggalLahir)}}</div>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kota</b-col>
                    <b-col v-if="anggota.detail.kotaKtp.id != null">{{ anggota.detail.kotaKtp.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kecamatan</b-col>
                    <b-col v-if="anggota.detail.kecamatanKtp.id != null">{{ anggota.detail.kecamatanKtp.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelurahan</b-col>
                    <b-col v-if="anggota.detail.kelurahanDesaKtp.id != null">{{ anggota.detail.kelurahanDesaKtp.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">RT/RW</b-col>
                    <b-col v-if="anggota.detail.rtKtp != '' && anggota.detail.rwKtp != ''">{{ anggota.detail.rtKtp }}/{{ anggota.detail.rwKtp }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat KTP</b-col>
                    <b-col v-if="anggota.detail.alamatKtp != null">{{ anggota.detail.alamatKtp }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat Tempat Kerja</b-col>
                    <b-col v-if="anggota.detail.alamatTempatKerja != null">{{ anggota.detail.alamatTempatKerja }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Telepon Tempat Kerja</b-col>
                    <b-col v-if="anggota.detail.teleponTempatKerja != null">{{ anggota.detail.teleponTempatKerja }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Pekerjaan</b-col>
                    <b-col v-if="anggota.detail.pekerjaanBaru != null">{{ anggota.detail.pekerjaanBaru.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA ANGGOTA</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                    <b-col v-if="anggota.detail.noHandphoneSekarang != null">{{ anggota.detail.noHandphoneSekarang }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kota</b-col>
                    <b-col v-if="anggota.detail.kotaSekarang.id != null">{{ anggota.detail.kotaSekarang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kecamatan</b-col>
                    <b-col v-if="anggota.detail.kecamatanSekarang.id != null">{{ anggota.detail.kecamatanSekarang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelurahan</b-col>
                    <b-col v-if="anggota.detail.kelurahanDesaSekarang.id != null">{{ anggota.detail.kelurahanDesaSekarang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">RT/RW</b-col>
                    <b-col v-if="anggota.detail.rtSekarang != '' && anggota.detail.rwSekarang != ''">{{ anggota.detail.rtSekarang }}/{{ anggota.detail.rwSekarang }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat Sekarang</b-col>
                    <b-col v-if="anggota.detail.alamatSekarang != null">{{ anggota.detail.alamatSekarang }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nomor / Nama Gang</b-col>
                    <b-col v-if="anggota.detail.nomorGang != null">{{ anggota.detail.nomorGang }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nomor Rumah</b-col>
                    <b-col v-if="anggota.detail.nomorRumah != null">{{ anggota.detail.nomorRumah }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA KELUARGA</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Suami / Istri</b-col>
                    <b-col v-if="anggota.detail.namaSuamiAtauIstri != '' && anggota.detail.namaSuamiAtauIstri != null">{{ anggota.detail.namaSuamiAtauIstri }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Handphone Suami / Istri</b-col>
                    <b-col v-if="anggota.detail.noHandphoneSuamiIstri != '' && anggota.detail.noHandphoneSuamiIstri != null">{{ anggota.detail.noHandphoneSuamiIstri }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Ayah</b-col>
                    <b-col v-if="anggota.detail.namaAyah != '' && anggota.detail.namaAyah != null">{{ anggota.detail.namaAyah }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Handphone Ayah</b-col>
                    <b-col v-if="anggota.detail.noHandphoneAyah != '' && anggota.detail.noHandphoneAyah != null">{{ anggota.detail.noHandphoneAyah }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Ibu</b-col>
                    <b-col v-if="anggota.detail.namaIbu != '' && anggota.detail.namaIbu != null">{{ anggota.detail.namaIbu }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Handphone Ibu</b-col>
                    <b-col v-if="anggota.detail.noHandphoneIbu != '' && anggota.detail.noHandphoneIbu != null">{{ anggota.detail.noHandphoneIbu }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">PIHAK LAIN (Keluarga yang Tidak Serumah)</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama</b-col>
                    <b-col v-if="anggota.detail.namaPihakLain != '' && anggota.detail.namaPihakLain != null">{{ anggota.detail.namaPihakLain }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Hubungan</b-col>
                    <b-col v-if="anggota.detail.hubunganPihakLain != '' && anggota.detail.hubunganPihakLain != null">{{ anggota.detail.hubunganPihakLain }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                    <b-col v-if="anggota.detail.noHandphonePihakLain != '' && anggota.detail.noHandphonePihakLain != null">{{ anggota.detail.noHandphonePihakLain }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kota</b-col>
                    <b-col v-if="anggota.detail.kotaPihakLain.name != null">{{ anggota.detail.kotaPihakLain.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kecamatan</b-col>
                    <b-col v-if="anggota.detail.kecamatanPihakLain.name != null">{{ anggota.detail.kecamatanPihakLain.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelurahan</b-col>
                    <b-col v-if="anggota.detail.kelurahanDesaPihakLain.name != null">{{ anggota.detail.kelurahanDesaPihakLain.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">RT/RW</b-col>
                    <b-col v-if="anggota.detail.rtPihakLain != '' && anggota.detail.rwPihakLain != '' && anggota.detail.rtPihakLain != null && anggota.detail.rwPihakLain != null">
                        {{ anggota.detail.rtPihakLain }}/{{ anggota.detail.rwPihakLain }}
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat Sekarang</b-col>
                    <b-col v-if="anggota.detail.alamatPihakLain != '' && anggota.detail.alamatPihakLain != null">{{ anggota.detail.alamatPihakLain }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA FOTO</h6>
                <!-- <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Foto Identitas</b-col>
                    <b-col>
                        <a v-bind:href="anggota.detail.fotoKtp" target="_blank">
                            <img width="150px" :src="anggota.detail.fotoKtp" alt="Foto Identitas">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row> -->
                <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoFormSurvey)">
                    <b-col cols="4" class="detail-data-label">Form Survey</b-col>
                    <b-col>
                        <a v-bind:href="anggota.detail.fotoFormSurvey" target="_blank">
                            <img width="150px" :src="anggota.detail.fotoFormSurvey" alt="Form Survey">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoFormDataBpkb)">
                    <b-col cols="4" class="detail-data-label">Foto Form Data BPKB</b-col>
                    <b-col>
                        <a v-bind:href="anggota.detail.fotoFormDataBpkb" target="_blank">
                            <img width="150px" :src="anggota.detail.fotoFormDataBpkb" alt="Foto Form Data BPKB">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoPendukung1)">
                    <b-col cols="4" class="detail-data-label">Foto Pendukung 1</b-col>
                    <b-col>
                        <a v-bind:href="anggota.detail.fotoPendukung1" target="_blank">
                            <img width="150px" :src="anggota.detail.fotoPendukung1" alt="Foto Pendukung 1">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoPendukung2)">
                    <b-col cols="4" class="detail-data-label">Foto Pendukung 2</b-col>
                    <b-col>
                        <a v-bind:href="anggota.detail.fotoPendukung2" target="_blank">
                            <img width="150px" :src="anggota.detail.fotoPendukung2" alt="Foto Pendukung 2">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoPendukung3)">
                    <b-col cols="4" class="detail-data-label">Foto Pendukung 3</b-col>
                    <b-col>
                        <a v-bind:href="anggota.detail.fotoPendukung3" target="_blank">
                            <img width="150px" :src="anggota.detail.fotoPendukung3" alt="Foto Pendukung 3">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA IDENTITAS</h6>
                <b-table
                :items="anggota.identitas"
                :fields="[
                { key: 'jenisIdentitas', label: 'Jenis Identitas' },
                { key: 'noIdentitas', label: 'No Identitas' },
                { key: 'fotoIdentitas', label: 'Foto' },
                ]"
                small
                bordered
                responsive
            >

                <template #cell(fotoIdentitas)="{ item }">
                    <!-- <img
                        :src="item.fotoIdentitas"
                        @click="openPreview(item.fotoIdentitas)"
                        alt="foto"
                        style="width:56px;height:56px;object-fit:cover;border-radius:6px;border:1px solid #eee;"
                    /> -->
                    <b-button size="sm" variant="pgiBtn" name="bayarBtn"
                        @click="openPreview(item)">
                            <i class="fa fa-picture-o" aria-hidden="true"></i>
                        </b-button>
                </template>
                </b-table>
            </div>
            <div class="detail-data-wrapper mb-4" v-if="!isFromDetailAnggotaBaru">
                <h6 class="form-title">DATA GADAI</h6>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="daftarGadai" 
                    :fields="fields" 
                    :no-local-sorting="false"
                    @sort-changed="sortingChanged" 
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data gadai.
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="dark" v-if="row.item.status.name == 'Baru'">BARU</b-badge>
                        <b-badge variant="primary" v-else-if="row.item.status.name == 'Berjalan'">BERJALAN</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status.name == 'Void'">VOID</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status.name == 'Lunas'">LUNAS</b-badge>
                        <b-badge v-else>{{ row.item.status.name }}</b-badge>            
                    </template>
                    <template v-slot:head(status)>
                        Status 
                        <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                    </template>
                    <template v-slot:cell(nilaiPinjamanEfektif)="row">
                        <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.nilaiPinjamanAwal) }}</div>
                        <div class="text-right text-muted small">Sisa Rp. {{ $helper.addThousandSeparator(row.item.nilaiPinjamanEfektif) }}</div>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
                            <p class="mb-0">{{row.item.jenisBarang}}</p>
                            <p class="mb-0 smallText text-muted">{{row.item.merk}}</p>
                            <p class="mb-0 smallText text-muted">{{row.item.tipe}}</p>
                        </div>
                        <div v-else>
                            <p class="mb-0">{{row.item.jenisBarang}}</p>
                            <p class="mb-0 smallText text-muted">{{row.item.merk}}</p>
                            <p class="mb-0 smallText text-muted">{{row.item.tipe}}</p>
                        </div>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
            <div class="detail-edit-btn footer-btn-detail-master-anggota" v-show="!isModal && !isFromDetailAnggotaBaru">
                <b-button variant="pgiBtn" name="anggotaEditBtn" @click="editAnggota">Edit</b-button>
                <b-button variant="pgiBtn" name="checkHistoryBtn" @click="checkHistory">Histori Data Anggota</b-button>
                <!-- <b-button variant="pgiBtn" name="checkHistoryBtn" :to="`${$route.path}/rekening-anggota/`" >Bank Nasabah</b-button> -->
            </div>
            <slot
                name="from-anggota-baru"
                v-if="isFromDetailAnggotaBaru"
            />
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BARU</h6>
                <p class="smallText mb-0">Transaksi gadai yang baru diinput dan belum ditransaksikan. Seluruh gadai BARU yang tidak dieksekusi, akan dihapus keesokan harinya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BERJALAN</h6>
                <p class="smallText mb-0">Transaksi gadai aktif yang sudah dieksekusi dan dicetak SBGnya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">VOID</h6>
                <p class="smallText mb-0">Transaksi gadai sudah digugurkan (VOID).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">LUNAS</h6>
                <p class="smallText mb-0">Transaksi gadai sudah lunas.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <ModalPreview modalId="modal-preview-gadai-c" :fotoPreview="activeFotoPreview">
            <template #header>
                <div class="mb-3">
                    <p class="mb-0"><span class="font-bold">Nama:</span> {{ anggota.nama }}</p>
                    <p v-if="itemIdentitas" class="mb-0"><span class="font-bold">Jenis Identitas:</span> {{ itemIdentitas.jenisIdentitas }}</p>
                    <p v-if="itemIdentitas" class="mb-0"><span class="font-bold">No Identitas:</span> {{ itemIdentitas.noIdentitas }}</p>
                    <p class="mb-0"><span class="font-bold">No Anggota:</span> {{ anggota.no }}</p>
                </div>
            </template>
        </ModalPreview>
    </div>
</template>


<script>
import CONSTANTS from '@/constants'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'detail-anggota',
    components:{
        ModalPreview,
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                sortBy: null,
                sortDesc: null
            },
            anggota: [{
                fotoPendukung1: null,
                fotoPendukung2: null,
                fotoPendukung3: null
            }],
            fields: [
                { key: "noFaktur", label: "No. Faktur", sortable:true },
                { key: "noAnggota", label: "No. Anggota", sortable:true },
                { key: "namaAnggota", label: "Nama Anggota", sortable:true },
                { key: "jenisPinjaman", label: "Jenis Pinjaman", sortable:true },
                { key: "Barang", label: "Barang" },
                { key: "nilaiPinjamanEfektif", label: "Total Pinjaman", sortable:true },
                { key: "status", label: "Status" }
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            daftarGadai: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            activeFotoPreview: '',
            itemIdentitas: null,
        }
    }, 
    props: {
        isModal: { type: Boolean, default: false},
        isFromDetailAnggotaBaru: { type: Boolean, default: false},
        idAnggota: { type: Number}
    },
    computed: {
        STATUS_VERIFIKASI_ANGGOTA() {
            return CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            if(this.isModal){
                this.id = this.idAnggota
            }else{
                this.id = this.$route.params.id
            }

            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getSingleAnggota = this.$axios.get(`nasabah/${this.id}`).then(response => {
                this.anggota = response.data

                if (this.isFromDetailAnggotaBaru) {
                    this.$emit('onStatusDetail', response.data.statusVerifikasi)
                }

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            let getDaftarGadai = this.$axios.get(`nasabah/${this.id}/gadai/`+this.query).then(response => {
                this.daftarGadai = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getSingleAnggota, getDaftarGadai]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
                this.toggleBusy()
            })
        },


        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDaftarGadai(){
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            
            this.$axios.get(`nasabah/${this.id}/gadai/`+this.query).then(response => {
                this.daftarGadai = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onLimitChange(){
            this.toggleBusy()
            this.size = this.input.show
            this.perPage = this.input.show
            this.updateList(1, this.size)
        },

        onPageChange(){
            this.toggleBusy()
            this.updateList(this.currentPage, this.size)
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onSort()
            }
        },

        updateList(pg, sz){
            this.page = pg-1
            this.size = sz
            this.daftarGadai = []
            this.query = this.$helper.makeQuery(this.page, this.size)

            this.$axios.get(`nasabah/${this.id}/gadai/`+this.query).then(response => {
                this.daftarGadai = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
            })
        },

        onSort(){
            this.toggleBusy()
            this.page = 0

            this.query = this.$helper.makeQuery(this.page, this.size)

            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get(`nasabah/${this.id}/gadai/`+this.query).then(response => {
                this.daftarGadai = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
            })
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        editAnggota(){
            this.$router.push({
                path: `${this.$route.path}/edit`
            })
        },

        checkHistory(){
            this.$router.push({
                path: `${this.$route.path}/detail-history`
            })
        },

        openPreview(item){
            this.activeFotoPreview = item.fotoIdentitas
            this.itemIdentitas = item
            this.$bvModal.show("modal-preview-gadai-c")
        }
    },

    created(){
        this.init()
    }
}
</script>

<style scoped>
.footer-btn-detail-master-anggota {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
</style>